import agent from "../api/agent";

export interface EmailTemplate {
    id: string;
    subject: string;
    body: string;
    createdByUserId?: string;
    createdByUserName?: string;
    lastUpdatedAt?: string;
}

export interface EmailLayoutSettings {
    header: string;
    footer: string;
}

export type EmailTemplateStore = {
    templates: EmailTemplate[];
    loading: boolean;

    fetchTemplates: () => Promise<void>;
    createTemplate: (tpl: Partial<EmailTemplate>) => Promise<void>;
    updateTemplate: (tpl: EmailTemplate) => Promise<void>;
    deleteTemplate: (id: string) => Promise<void>;
    fetchLayoutSettings: () => Promise<EmailLayoutSettings | undefined>;
    saveLayoutSettings: (settings: EmailLayoutSettings) => Promise<void>;
};

export const createEmailTemplateStore = (set: any, _get: any): EmailTemplateStore => ({
    templates: [],
    loading: false,

    fetchTemplates: async () => {
        set((s: any) => ({ emailTemplateStore: { ...s.emailTemplateStore, loading: true } }));
        try {
            const res = await agent.Emails.getTemplates();
            set((s: any) => ({ emailTemplateStore: { ...s.emailTemplateStore, templates: res || [], loading: false } }));
        } catch (e) {
            console.error(e);
            set((s: any) => ({ emailTemplateStore: { ...s.emailTemplateStore, loading: false } }));
        }
    },

    createTemplate: async (tpl: Partial<EmailTemplate>) => {
        await agent.Emails.createTemplate(tpl);
        await (createEmailTemplateStore as any)(set, _get).fetchTemplates();
    },

    updateTemplate: async (tpl: EmailTemplate) => {
        await agent.Emails.updateTemplate(tpl);
        await (createEmailTemplateStore as any)(set, _get).fetchTemplates();
    },

    deleteTemplate: async (id: string) => {
        await agent.Emails.deleteTemplate(id);
        await (createEmailTemplateStore as any)(set, _get).fetchTemplates();
    },

    fetchLayoutSettings: async () => {
        try {
            const res = await agent.Emails.getLayoutSettings();
            return res as EmailLayoutSettings;
        } catch (e) {
            console.error(e);
        }
    },

    saveLayoutSettings: async (settings: EmailLayoutSettings) => {
        await agent.Emails.saveLayoutSettings(settings);
    },
});
